/**
 * The one label order every option list in the CMS uses. `sensitivity: 'base'`
 * so a lower-case name files under its letter instead of after Z and Dutch
 * accents do not split adjacent entries; `numeric` so "Lane 10" follows
 * "Lane 9".
 */
const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

export const compareLabels = (left: string, right: string) =>
  collator.compare(left, right);

export const sortByLabel = <T>(
  items: readonly T[],
  labelOf: (item: T) => string
): T[] =>
  [...items].sort((left, right) =>
    compareLabels(labelOf(left), labelOf(right))
  );

/**
 * A multi-select's menu order: the chosen options first, then the rest, each
 * group alphabetical. Pass the selection the menu OPENED with (see
 * `useOpenSnapshot`), not the live one, or a row jumps to the top under the
 * pointer that just ticked it.
 */
export const orderSelectedFirst = <T>(
  items: readonly T[],
  isSelected: (item: T) => boolean,
  labelOf: (item: T) => string
): T[] => {
  return [
    ...sortByLabel(items.filter(isSelected), labelOf),
    ...sortByLabel(
      items.filter(item => !isSelected(item)),
      labelOf
    ),
  ];
};
